<template>
    <div class="input-group input-group-sm">
        <input
            type="search"
            name="table_search"
            :class="['form-control', { 'py-4': big }]"
            placeholder="Buscar"
            v-model="searchValue"
            @input="debouncedEmitInput"
            :disabled="disabled"
            class="rounded-search"
        />

        <div class="input-group-append">
            <Button
                data-cy="submit-search"
                type="submit"
                variant="default"
                icon="fas fa-search"
                :disabled="disabled"
                class="rounded-lupa"
            />
        </div>
    </div>
</template>

<script>
    export default {
        props: ["value", "disabled", "big"],
        data() {
            return {
                searchValue: this.value,
            };
        },
        created() {
            this.debouncedEmitInput = _.debounce(this.emitInput, 200);
        },
        watch: {
            value(newValue) {
                this.searchValue = newValue;
            },
        },
        methods: {
            emitInput() {
                this.$emit("input", this.searchValue);
            },
        },
    };
</script>
<style scoped>
    .rounded-search {
        border-radius: 30px 0 0 30px !important;
    }

    .rounded-lupa {
        border-radius: 0 30px 30px 0 !important;
    }
</style>